var beneficiaryTypeDelimiter = ":";

export default beneficiaryTypeDelimiter;
